import PropTypes from 'prop-types';
import {chunk} from 'lodash';
import moment from 'moment';
import {Loading} from './loading';

import {getWeek, retrieveSchedulableWindows} from '../utils/scheduled-window';

import StyledTD from './styledTd';
import DayCell from './day-cell';

const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const Calendar = ({isLoading, schedulableWindows, selectDay, selectedDay}) => {
  const weekStart = selectedDay.clone().startOf('month').startOf('week');
  const lastDay = selectedDay.clone().endOf('month').endOf('week');
  const weeks = [];

  while (weekStart.clone().endOf('week').isSameOrBefore(lastDay, 'day')) {
    const weekDay = weekStart.isSame(selectedDay, 'week') ? selectedDay.clone() : weekStart.clone();
    weeks.push(weekDay);
    weekStart.add(1, 'week');
  }

  const days = weeks.reduce((dayCells, week) => {
    return dayCells.concat(getWeek(week));
  }, []);

  return (
    <div className={styles.calendarContainer}>
      {isLoading ? (
        <div className={styles.spinnerContainer}>
          <Loading />
        </div>
      ) : (
        <table className={styles.table}>
          <thead>
            <tr>
              {daysOfWeek.map((dayOfWeek, i) => (
                <StyledTD key={i}>{dayOfWeek}</StyledTD>
              ))}
            </tr>
          </thead>

          <tbody>
            {chunk(days, 7).map((weekDays, week) => (
              <tr key={week}>
                {weekDays.map((d, i) => (
                  <DayCell
                    day={d}
                    disabled={isLoading || !retrieveSchedulableWindows(schedulableWindows, d).length}
                    key={`day_cell: ${d.day()}${i}`}
                    onClick={selectDay}
                    selectedDay={selectedDay}
                  />
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

Calendar.propTypes = {
  isLoading: PropTypes.bool,
  schedulableWindows: PropTypes.object,
  selectDay: PropTypes.func,
  selectedDay: PropTypes.instanceOf(moment),
};

Calendar.defaultProps = {
  isLoading: false,
  schedulableWindows: {},
  selectDay: () => {},
};

const styles = {
  calendarContainer: `
    flex justify-center items-stretch border border-border h-[500px] w-[80%]
    max-[576px]:h-auto max-[576px]:w-full
  `,
  table: 'w-full h-full',
  spinnerContainer: 'flex items-center justify-center w-full h-full flex-1',
};

export default Calendar;
